import React from 'react' 
import './about.css'
import ME from '../../assets/me-about.jpg'


const About = () => {
  return (
    <section id='about'>
      <h4>Get To Know</h4>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          {/*
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>3+ Years Working</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>200+ Worldwide</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>80+ Projects</small>
            </article>
          </div>
          */}

          <p>
            I am a UBC Mechanical Engineering student currently completing my 3rd year of studies, with a long-time interest in mechanical design, prototyping, and manufacturing. I've recently completed two co-op terms, one with Ford's Advanced EV Development team working on aerodynamic prototyping, and another at Tesla working on product design of low-voltage electronics.<br /><br /> I am also a member of the Formula UBC Racing design team, where I have served as the lead of our Materials and Manufacturing subteam, as well as working on our Brakes & Controls and most recently our Suspension subteams. If I'm not busy with work, I aim to always be working on projects both in and out of school - visit the portfolio section to learn more! <br /><br />In my (rare) free time, I love being outside, whether I'm hiking through B.C.'s backcountry, snowboarding, cycling, or playing basketball. No matter where I am, you're sure to find me with my camera - you can see my photography <a href="https://www.instagram.com/jonas.photograff/" target='_blank'>@jonas.photograff</a> on Instagram.
          </p>

          {/*<a href="#contact" className='btn btn-primary'>Let's Talk</a>*/}
        </div>
      </div>
    </section>
  )
}

export default About